import React from 'react'

const Footer = () => {
  return (
    <div className='w-full bg-slate-100'>
        <div className='max-w-[1600px] w-full bg-slate-100 mx-auto'>
            <div className='flex justify-center items-center md:items-start flex-col md:flex-row text-center'>
            <div className='w-[30%]  py-[20px] md:py-[30px] mb-[5px] md:mb-[0px] '>
                <h1 className='text-[20px] md:text-[30px] font-semibold mb-[15px] font-poppins'>Quick Links</h1>
                <p className='text-[15px] md:text-[16.5px] font-figtree'>Home</p>
                <p className='text-[15px] md:text-[16.5px] font-figtree'>Why we exist</p>
                
            </div>
            <div className='w-[30%]  py-[20px] md:py-[30px] mb-[5px] md:mb-[0px]'>
                <h1 className='text-[20px] md:text-[30px] font-semibold mb-[15px] font-poppins' >Contact Info</h1>
                <p>numero</p>
                <p>email</p>
                <p>adresse</p>
            </div>
            <div className='w-[30%]  py-[20px] md:py-[30px] mb-[5px] md:mb-[0px]'>
                <h1 className='text-[20px] md:text-[30px] font-semibold mb-[15px] font-poppins'>Follow us</h1>
                <p>facebook</p>
                <p>twitter</p>
                <p>instagram</p>
            </div>
            </div>
            
        </div>
        <div className='w-full bg-white'>
        <div className='text-center max-w-[1600px] py-[10px] font-poppins bg-white text-[14px] md:text-[15px] mx-auto'>Created by AlloMoniteur - 2024</div>
        </div>
        
      
    </div>
  )
}

export default Footer
